


export const BottomForm=()=>{

    return(
        <div className="bottom-form_bg">
            <div className="bottom-form_section __container">
                <div className="bottom-form_form-placeholder ">
                    <h1>A quick way to discuss details</h1>
                    <div className="bottom-form_form-input-block">
                        <label htmlFor='nameInput'>Name*</label>
                        <input id='nameInput' placeholder="Your name"/>
                    </div>
                    <div className="bottom-form_form-input-block">
                        <label htmlFor='phoneInput'>Phone*</label>
                        <input id='phoneInput' placeholder="Your phone number"/>
                    </div>
                    <div className="bottom-form_form-input-block">
                        <label htmlFor='emailInput'>email*</label>
                        <input id='emailInput' placeholder="Your working email"/>
                    </div>
                    <div className="bottom-form_form-input-block">
                        <label htmlFor='messageInput'>message*</label>
                        <textarea id='messageInput' placeholder="Your message"/>
                    </div>
                    <div className="bottom-form_form-checkbox-block">
                        <input id="agreement" checked type="checkbox"/>
                        <label htmlFor="agreement">I agree to receive communications from Createx Construction Bureau.</label>
                    </div>
                    <div className="bottom-form_link">
                        <a href="#"><p>send request</p></a>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}